import React from 'react';
import DelayLink from './DelayLink';
import { pageChangeStart, pageChangeEnd } from '../../actions/';
import { connect } from 'react-redux';

const LinkEffect = ({ dispatch, ...props }) => <DelayLink {...props} delay={400} onDelayStart={() => dispatch(pageChangeStart()) } onDelayEnd={() => dispatch(pageChangeEnd())  } />

export { LinkEffect }
export default connect()(LinkEffect);



// WEBPACK FOOTER //
// ./src/components/commons/LinkEffect.js